import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PalOfferDTO } from "@smartx/mikro-vt-client-api"
import { offerPreApprovedLoansApi } from "../../api/apiClient"
import type { RootState } from "../store"

interface IPalOffersState {
  error: boolean
  isLoading: boolean
  list: Array<PalOfferDTO>
  selected: PalOfferDTO
}

const initialState: IPalOffersState = {
  error: false,
  isLoading: false,
  list: undefined,
  selected: null,
}

export const getOffers = createAsyncThunk("offers/getOffers", async () => {
  const response = await offerPreApprovedLoansApi.getPreApprovedLoans()
  return response?.data
})

export const offersSlice = createSlice({
  name: "offers",
  initialState,
  reducers: {
    setOffer: (state, action: PayloadAction<PalOfferDTO>) => {
      state.selected = action.payload
    },
    setOffers: (state, action: PayloadAction<PalOfferDTO[]>) => {
      state.list = action.payload
    },
    clearOffer: (state) => {
      state.selected = null
    },
    clearOffers: (state) => {
      state.list = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOffers.pending, (state) => {
        state.isLoading = true
        state.error = false
      })
      .addCase(getOffers.fulfilled, (state, action) => {
        state.list = action.payload.palOffers
        state.isLoading = false
        state.error = false
        state.selected = null
      })
      .addCase(getOffers.rejected, (state) => {
        state.list = undefined
        state.isLoading = false
        state.error = true
        state.selected = null
      })
  },
})

export const { setOffer, setOffers, clearOffer, clearOffers } =
  offersSlice.actions

export const selectOffers = (state: RootState) => state.offers.list

export default offersSlice.reducer
